import React from 'react';

import { Sprite, SpriteName } from '../../Sprite';
import T from '../../Translate';

export default function InstantBookingTripModalBody() {
  return (
    <>
      <h2 className="mb-4 text-center" id="reservationLabel">
        <T id="modals.trip.reservationConfirmed" multiline />
      </h2>
      <ul className="list__status mb-0">
        <li className="list__status--item mb-3">
          <figure>
            <Sprite name={SpriteName.INFO} />
          </figure>
          <T as="span" className="text-muted font-size-lg text-left" id="modals.trip.findDetailsAboutTrip" />
        </li>
        <li className="list__status--item">
          <figure />
          <T as="span" className="text-muted font-size-lg text-left" id="modals.trip.getReadyForTrip" />
        </li>
      </ul>
    </>
  );
}
